import './styles.css';
import { Game } from './game/Game.js';
import { createRenderer } from './game/renderer.js';

const canvas = document.querySelector('#game-canvas');
const app = document.querySelector('#app');
const renderer = await createRenderer(canvas);
const game = new Game({ renderer, canvas, root: app });

if (['127.0.0.1', 'localhost'].includes(window.location.hostname)) {
  Object.defineProperty(globalThis, '__AIRWAR_TEST__', {
    configurable: false,
    enumerable: false,
    value: game,
    writable: false
  });
}
